import Modal from "../../designComponents/Modal";
import {
  AcceptButton,
  LabelText,
  SectionTitle,
} from "../Properties/Details/styles";
import { Input, InputGroup } from "./styles";

export interface PricingSettings {
  perDayRate: number;
  weeklyDiscountRate: number;
  monthlyDiscountRate: number;
  currency: "EUR";
  flatFee: number;
  percentageFee: number;
  stripeFeePercentage: number;
  stripeFeeRate: number;
}
function AddPlatformSettings({
  isOpen,
  onClose,
  onAddPress,
  setData,
  initialValues,
}: {
  isOpen: boolean;
  onClose: () => void;
  onAddPress: () => void;
  setData: React.Dispatch<React.SetStateAction<PricingSettings>>;
  initialValues: PricingSettings;
}) {
  const handleChange = (field: keyof PricingSettings, value: string) => {
    const numValue = parseFloat(value) || 0;
    setData((prev) => ({
      ...prev,
      [field]: numValue,
    }));
  };
  return (
    <Modal
      isOpen={isOpen}
      halfWidth={true}
      onClose={onClose}
      title="Add Platform Fee"
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <SectionTitle>Platform Fee</SectionTitle>
          <InputGroup>
            <LabelText>Percentage Fee (%)</LabelText>
            <Input
              type="number"
              value={initialValues.percentageFee}
              onChange={(e) => handleChange("percentageFee", e.target.value)}
              placeholder="Enter per day rate"
            />
          </InputGroup>

          <InputGroup>
            <LabelText>Flat Fee(€)</LabelText>
            <Input
              type="number"
              value={initialValues.flatFee}
              onChange={(e) => handleChange("flatFee", e.target.value)}
              placeholder="Enter weekly discount"
              min="0"
              max="100"
            />
          </InputGroup>
        </div>
      </div>
      <AcceptButton onClick={onAddPress}>Save</AcceptButton>
    </Modal>
  );
}

export default AddPlatformSettings;
